import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReportRunnerComponent } from '../../components/report-runner/report-runner.component';

@Component({
  selector: 'app-outreach-contacts-report',
  imports: [ReportRunnerComponent],
  templateUrl: './outreach-contacts-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutreachContactsReportComponent {}
